import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { MainAppReducer } from 'Types';
import * as appActions from '../../Actions/app';
import { CustomSwitch } from 'Components';
import { useMidiContext } from 'Contexts/MidiContext';
import { FeatureFlag, useFeatureFlag } from 'Utils/FeatureFlags';

const Keyboard = () => {
  const data = useSelector((state: MainAppReducer) => state.mainAppReducer);

  const { userData } = data;

  const dispatch = useDispatch();
  const { preferredInputMode, setPreferredInputMode } = useMidiContext();
  const audioRecognitionEnabled = useFeatureFlag(FeatureFlag.USE_AUDIO_RECOGNITION);
  const showPreferredInputSelection =
    process.env.REACT_APP_NODE_ENV === 'local' ||
    process.env.REACT_APP_NODE_ENV === 'dev' ||
    import.meta.env.DEV ||
    (typeof window !== 'undefined' && window.location.hostname === 'localhost');

  return (
    <Box sx={{ height: 'calc(100vh - 200px)', overflow: 'scroll' }}>
      <Box
        sx={{
          marginLeft: '50px',
          width: '600px',
          backgroundColor: 'black',
          borderRadius: '5px',
        }}
      >
        <Box
          sx={{
            color: 'white',
            textAlign: 'left',
            marginLeft: '24px',
            marginRight: '24px',
            marginTop: '20px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              marginTop: '20px',
              marginBottom: '20px',
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: '26px',
              letterSpacing: '0.01em',
              color: '#FFFFFF',
              fontFamily: 'Lato',
            }}
          >
            Keyboard Settings
          </Box>
          {/* <Box sx={{marginBottom: '20px', display: 'flex', flexDirection: 'column'}}>
          <Box sx={{display:'flex', alignItems:'center', height: '25px'}}><img style={{height:"100%", marginRight: '10px'}} src={pianoIcon}/> Keyboard Range:</Box>
          <Box sx={{marginTop: '10px', marginLeft: '35px', display: 'flex'}}>
            <Box sx={{
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: '16px',
              letterSpacing: '0.01em',
              color: '#ECECEC',
            }}>88 keys</Box>
            <Box sx={{
              marginLeft: '7px',
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: '16px',
              letterSpacing: '0.01em',
              color: '#767C8C',
            }}>A0-C8</Box>
            <Box sx={{
              marginLeft: '7px',
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: '16px',
              letterSpacing: '0.01em',
              textDecorationLine: 'underline',
              color: '#469F6A',
            }}>Edit</Box>
          </Box>
        </Box> */}
          <Box sx={{ marginBottom: '20px', fontFamily: 'Lato' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: '8px',
                marginTop: '5px',
              }}
            >
              <Box
                sx={{
                  fontStyle: 'normal',
                  fontWeight: '400',
                  fontSize: '16px',
                  letterSpacing: '0.01em',
                  color: userData?.audio_on ? '#767C8C' : '#ECECEC',
                  transition: 'color 0.2s',
                }}
              >
                Keyboard Speakers
              </Box>
              <CustomSwitch
                checked={userData?.audio_on ?? true}
                onChange={(e) => {
                  dispatch(appActions.setAudioOn({ audioOn: e.target.checked }));
                }}
              />
              <Box
                sx={{
                  fontStyle: 'normal',
                  fontWeight: '400',
                  fontSize: '16px',
                  letterSpacing: '0.01em',
                  color: userData?.audio_on ? '#ECECEC' : '#767C8C',
                  transition: 'color 0.2s',
                }}
              >
                Device Speakers
              </Box>
            </Box>
          </Box>

          {showPreferredInputSelection && (
            <Box sx={{ marginBottom: '24px', fontFamily: 'Lato' }}>
              <Box
                sx={{
                  fontStyle: 'normal',
                  fontWeight: '400',
                  fontSize: '16px',
                  letterSpacing: '0.01em',
                  color: '#ECECEC',
                  marginBottom: '10px',
                }}
              >
                Preferred Input
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  gap: '10px',
                  flexWrap: 'wrap',
                }}
              >
                <Box
                  onClick={() => {
                    setPreferredInputMode('midi');
                  }}
                  sx={{
                    padding: '10px 14px',
                    borderRadius: '999px',
                    border:
                      preferredInputMode === 'midi'
                        ? '1px solid #7FD7FF'
                        : '1px solid rgba(255,255,255,0.18)',
                    backgroundColor:
                      preferredInputMode === 'midi' ? 'rgba(127, 215, 255, 0.14)' : 'transparent',
                    color: preferredInputMode === 'midi' ? '#ECECEC' : '#9CA3AF',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                  }}
                >
                  MIDI Keyboard
                </Box>
                <Box
                  onClick={() => {
                    if (!audioRecognitionEnabled) return;
                    setPreferredInputMode('audio');
                  }}
                  sx={{
                    padding: '10px 14px',
                    borderRadius: '999px',
                    border:
                      preferredInputMode === 'audio'
                        ? '1px solid #7FD7FF'
                        : '1px solid rgba(255,255,255,0.18)',
                    backgroundColor:
                      preferredInputMode === 'audio' ? 'rgba(127, 215, 255, 0.14)' : 'transparent',
                    color: audioRecognitionEnabled
                      ? preferredInputMode === 'audio'
                        ? '#ECECEC'
                        : '#9CA3AF'
                      : '#5B6474',
                    cursor: audioRecognitionEnabled ? 'pointer' : 'not-allowed',
                    transition: 'all 0.2s ease',
                  }}
                >
                  Audio Recognition
                </Box>
              </Box>
              <Box
                sx={{
                  marginTop: '10px',
                  fontSize: '13px',
                  color: 'rgba(236,236,236,0.62)',
                }}
              >
                Default is MIDI. This selector is only exposed in local/dev builds.
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Keyboard;
